import React from "react";
import PropTypes from "prop-types";
import { calculateCost } from "LIB/formatters/currency";
import { properCase } from "LIB/formatters/text";
import {
  TOTAL_CYCLES_REMAINING,
  TOTAL_HOURS_REMAINING
} from "MODULES/inventories/constants";

export default function Total({
  part,
  quantity,
  pricePerUnit,
  totalCyclesRemaining,
  totalHoursRemaining
}) {
  return (
    <div className="well">
      <h6 className="h4">Outgoing Quote Summary</h6>
      <table className="table table-condensed table-padding-horizonal-none margin-bottom-none">
        <tbody>
          <tr>
            <td>
              Part #{part && part.part_number}
              <br />
              <em className="text-muted">{part && part.description}</em>
            </td>
            <td className="text-right" />
          </tr>
          {totalCyclesRemaining && (
            <tr>
              <td>{properCase(TOTAL_CYCLES_REMAINING)}</td>
              <td>{totalCyclesRemaining}</td>
            </tr>
          )}
          {totalHoursRemaining && (
            <tr>
              <td>{properCase(TOTAL_HOURS_REMAINING)}</td>
              <td>{totalHoursRemaining}</td>
            </tr>
          )}
        </tbody>
      </table>
      <hr className="hr-xs" />
      <table className="table table-condensed table-padding-horizonal-none">
        <tbody>
          <tr>
            <td>
              <h5 className="h4 margin-top-none margin-bottom-none">Total</h5>
            </td>
            <td className="text-right">
              <h5 className="h4 margin-top-none margin-bottom-none">
                {calculateCost(quantity, pricePerUnit)}
              </h5>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

Total.propTypes = {
  part: PropTypes.shape({
    part_number: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
  }),
  quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  pricePerUnit: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  totalCyclesRemaining: PropTypes.number,
  totalHoursRemaining: PropTypes.number
};



// WEBPACK FOOTER //
// ./app/modules/OutgoingQuotes/shared/Total.jsx